export const noop = () => { };
export const oneOf = (a, b) => {
    return {
        isFirst: (value) => value === a,
        toggle: (value) => (value === a ? b : a),
        valueType: a,
    };
};
